import { CSSProperties, MouseEvent, ReactElement } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip, TooltipProps } from '@arkestro/arkestro-design-system';

interface TooltipInfoIconProps {
  className?: string;
  dataTestId?: string;
  iconClassName?: string;
  iconOnClick?: (e: MouseEvent) => void;
  iconStyle?: CSSProperties;
  overlayStyle?: CSSProperties;
  placement?: TooltipProps['placement'];
  title: ReactElement | string;
}

export const TooltipInfoIcon = ({
  className,
  iconClassName,
  iconOnClick,
  iconStyle,
  title,
  dataTestId,
  ...props
}: TooltipInfoIconProps) => {
  const iconStyles = { marginLeft: '5px', ...iconStyle };

  return (
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    <Tooltip className={className} title={title as any} {...props}>
      <InfoCircleOutlined className={iconClassName} data-testid={dataTestId} onClick={iconOnClick} style={iconStyles} />
    </Tooltip>
  );
};
